import { Link, useRouteError } from 'react-router-dom'
import { routes } from '@/router'
import { Container, Box, Typography, Button } from '@mui/material'
import roboImage from '@/assets/images/robo-triste.png'
import { captureException } from '@sentry/react'
import { useEffect } from 'react'

export function ErrorPage() {
  const error = useRouteError() as Error

  useEffect(() => {
    captureException(error)
  }, [error])

  return (
    <Container>
      <Box
        height="100vh"
        margin="auto"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Box component="img" src={roboImage} alt="" sx={{ width: 200 }} />

        <Typography variant="h2">Oops!</Typography>
        <Typography fontSize={18}>
          Desculpe, ocorreu um erro inesperado.
        </Typography>

        <Button component={Link} to={routes.home}>
          Voltar para a home
        </Button>
      </Box>
    </Container>
  )
}
